import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { DocumentType } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-full-data-input-document',
    templateUrl: './full-data-input-document.component.html',
    styleUrls: ['./full-data-input-document.component.scss'],
})
export class FullDataInputDocumentComponent extends BaseUI implements AfterViewInit, OnDestroy {
    public DocumentType: typeof DocumentType = DocumentType;

    @Input()
    prefix: string;

    @Input()
    name = 'Document';

    @Input()
    docType: DocumentType;

    @Input()
    isDisabled = false;

    @Input()
    value: string;

    @Output()
    valueChange: EventEmitter<string> = new EventEmitter();

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    onValueChange() {
        this.valueChange.emit(this.value);
    }
}
